import React from 'react'
import { createPortal } from 'react-dom'
import { v4 as uuidv4 } from 'uuid'
import { compose, withState, withHandlers, lifecycle } from 'recompose'
import ToastItem from './ToastItem'

const ToastView = ({ toasts, removeToast, isMounted }) => {
  if (!isMounted || typeof document === 'undefined') return null

  return createPortal(
    <div className="fixed top-0 left-0 w-full z-[99999] pointer-events-none">
      {toasts.map((toast) => (
        <ToastItem
          key={toast.id}
          {...toast}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </div>,
    document.body,
  )
}

export default compose(
  withState('toasts', 'setToasts', []),
  withState('isMounted', 'setIsMounted', false),

  withHandlers({
    removeToast:
      ({ setToasts }) =>
      (id) => {
        setToasts((prev) => prev.filter((t) => t.id !== id))
      },
  }),

  lifecycle({
    componentDidMount() {
      this.props.setIsMounted(true)

      this.handleToast = (event) => {
        const { type, message } = event.detail
        this.props.setToasts((prev) => [
          ...prev,
          { id: uuidv4(), type, message },
        ])
      }

      window.addEventListener('SHOW_TOAST', this.handleToast)
    },

    componentWillUnmount() {
      if (typeof window !== 'undefined' && this.handleToast) {
        window.removeEventListener('SHOW_TOAST', this.handleToast)
      }
    },
  }),
)(ToastView)
